export enum EditUserDataType {
  Email = 1,
  Password = 2
};
